import { Helmet } from 'react-helmet';

import { Content, Header, Layout, PageTitle } from '@eluve/components';

import { TenantsList } from './components/TenantsList';

export const TenantsPage = () => {
  return (
    <Layout type="simple">
      <Helmet>
        <title>Select an Organization | Eluve</title>
      </Helmet>
      <Header>
        <PageTitle>Select an Organization</PageTitle>
      </Header>
      <Content padded>
        <TenantsList />
      </Content>
    </Layout>
  );
};
